<template>
  <b-container class="search-area" fluid="lg">
    <b-form-row class="mb-3">
      <b-col>
        <h3 class="common__search-title">Tutor</h3>
          <input
            type="text"
            class="search-tutor"
            v-model="conditions.tutor"
          >
      </b-col>
      <b-col>
        <h3 class="common__search-title">University</h3>
        <University v-model="conditions.university" />
      </b-col>
      <b-col>
        <h3 class="common__search-title">Type</h3>
          <div>
            <label class="checkbox">
              <input
                value="late"
                type="checkbox"
                v-model="conditions.deadlineInTimes"
              >
              Late
            </label>
            <label class="checkbox">
              <input
                value="inTime"
                type="checkbox"
                v-model="conditions.deadlineInTimes"
              >
              On Time
            </label>
            <label class="checkbox">
              <input
                value="send"
                type="checkbox"
                v-model="conditions.deadlineSends"
              >
              Submitted
            </label>
            <label class="checkbox">
              <input
                value="unsent"
                type="checkbox"
                v-model="conditions.deadlineSends"
              >
              Not Submitted
            </label>
          </div>
      </b-col>
    </b-form-row>
    <h3 class="common__search-title">■Deadline</h3>
    <b-form-row class="mb-3">
      <b-col>
        <p>From</p>
        <DatetimeInput v-model="conditions.deadlineFrom" />
      </b-col>
      <b-col>
        <p>To</p>
        <DatetimeInput v-model="conditions.deadlineTo" />
      </b-col>
    </b-form-row>
    <h3 class="common__search-title">■Lesson Date</h3>
    <b-form-row class="mb-3">
      <b-col>
        <p>From</p>
        <DateInput v-model="conditions.lessonDateFrom" />
      </b-col>
      <b-col>
        <p>To</p>
        <DateInput v-model="conditions.lessonDateTo" />
      </b-col>
    </b-form-row>
    <b-form-row class="mb-3">
      <b-col>
        <h3 class="common__search-title">Level</h3>
        <LevelsInput v-model="conditions.levels" />
      </b-col>
      <b-col>
        <h3 class="common__search-title">Task Type</h3>
        <TaskTypesInput v-model="conditions.types" />
      </b-col>
    </b-form-row>
    <div class="d-flex justify-content-end">
      <b-button
        pill
        variant="secondary"
        @click="reset"
        class="mr-2"
      >
        Reset
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="search"
      >
        Search
      </b-button>
    </div>
  </b-container>
</template>

<script lang='ts'>
import Vue from 'vue'
import _ from 'lodash';
import LevelsInput from '@/components/parts/inputItem/LevelsInput.vue';
import TaskTypesInput from '@/components/parts/inputItem/TaskTypesInput.vue';
import DateInput from '@/components/parts/inputItem/DateInput.vue';
import DatetimeInput from '@/components/parts/inputItem/DatetimeInput.vue';
import { DeadlineConditions } from '@/store/deadlines/types';
import University from '@/components/parts/inputItem/SelectUniversityInput.vue';

// 検索の初期設定値
const initialConditions: DeadlineConditions = {
  tutor: null,
  university: {
    abbreviation: 'W',
    code: '01',
    name: 'waseda',
  },
  deadlineInTimes: [],
  deadlineSends: [],
  deadlineFrom: null,
  deadlineTo: null,
  lessonDateFrom: null,
  lessonDateTo: null,
  levels: [],
  types: [],
}

export default Vue.extend({
  data() {
    return {
      conditions: _.cloneDeep(initialConditions),
    };
  },

  components: {
    LevelsInput,
    DateInput,
    DatetimeInput,
    TaskTypesInput,
    University,
  },

  methods: {
    search() {
      // 検索ボタン押した場合
      this.$emit('search', this.conditions)
    },
    reset() {
      // リセットボタン押した場合
      this.conditions = _.cloneDeep(initialConditions);
      this.search();
    },
  },
  created() {
    this.search();
  },
});

</script>

<style scoped>
input[type="text"], select{
  padding: 5px;
  border: 1px solid hsl(215, 8%, 69%);
  border-radius: 30px;
  width: 150px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

input[type="checkbox"] {
  margin-right:8px;
  vertical-align: middle;
}

.checkbox {
  margin-right:20px;
}
</style>
